import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { License } from "@/types";

// Alle Lizenzen oder — mit customerId — die eines Kunden. Der customerId-Filter
// steckt im QueryKey, damit Kunden-Detail und die volle Liste getrennt cachen.
export function useLicenses(customerId?: string): UseQueryResult<License[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: customerId
      ? [...queryKeys.list("licenses"), "customer", customerId]
      : queryKeys.list("licenses"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      const q = customerId ? `?customerId=${encodeURIComponent(customerId)}` : "";
      return client.get<License[]>(`/licenses${q}`);
    },
    enabled: !!session,
  });
}

export function useLicense(id: string | undefined): UseQueryResult<License> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: id ? queryKeys.detail("licenses", id) : ["resources", "licenses", "_invalid"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<License>(`/licenses/${id}`);
    },
    enabled: !!id && !!session,
  });
}
